import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, MessageCircleIcon } from 'lucide-react';
const HERO_IMG = 'https://cdn.magicpatterns.com/uploads/hdp1NyxoBWtsdDB2DSPqmb/SalaHero.webp';
export function Hero() {
  return <section id="home" className="relative min-h-[100svh] w-full overflow-hidden" data-id="element-114" data-mp="9lbfcytwl7cj">
      <img src={HERO_IMG} alt="A sunlit, immaculately clean luxury Manhattan living room with skyline views" className="absolute inset-0 h-full w-full object-cover" data-id="element-115" data-mp="4n9wadwh9812" />
      <div className="absolute inset-0 bg-gradient-to-r from-slate/80 via-slate/45 to-slate/10" data-id="element-116" data-mp="xaxexne6tol2" />
      <div className="absolute inset-0 bg-gradient-to-t from-slate/60 via-transparent to-transparent" data-id="element-117" data-mp="s9q8psrp0xgi" />

      <div className="relative z-10 mx-auto flex min-h-[100svh] max-w-7xl items-center px-5 sm:px-8 pt-20" data-id="element-118" data-mp="nbygexn4z9bs">
        <div className="max-w-2xl" data-id="element-119" data-mp="3czfkty10i55i">
          <motion.span initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-xs font-medium uppercase tracking-[0.18em] text-white backdrop-blur-sm ring-1 ring-white/25" data-id="element-120" data-mp="382p91mw8pvpw">
            Boutique Cleaning · New York City
          </motion.span>

          <motion.h1 initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.08
        }} className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] tracking-tight text-white" data-id="element-121" data-mp="30h9d5w8vq9ov">
            The Luxury Boutique Standard for NYC Homes.
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.16
        }} className="mt-6 max-w-xl text-base sm:text-lg leading-relaxed text-white/85" data-id="element-122" data-mp="2lk8vymobdx4n">
            Professional, detailed, and eco-friendly cleaning tailored to your
            Manhattan, Queens &amp; Long Island lifestyle. We treat your
            sanctuary with the care it deserves.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.24
        }} className="mt-9 flex flex-col sm:flex-row sm:items-center gap-4" data-id="element-123" data-mp="162lz52g3rzqu">
            <a href="#quote" className="group inline-flex items-center justify-center gap-2 rounded-full bg-magenta px-8 py-4 text-base font-semibold text-white shadow-xl shadow-magenta/30 hover:bg-magenta-dark transition-all" data-id="element-124" data-mp="3hqkbsklh5wuf">
              Request Free Quote
              <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-125" data-mp="2697ouo46fa0r" />
            </a>
            <a href="sms:+19296509940" className="inline-flex items-center justify-center gap-2 rounded-full px-5 py-4 text-base font-medium text-white hover:text-sky-brand transition-colors" data-id="element-126" data-mp="2b20q320fs083">
              <MessageCircleIcon className="h-4 w-4" data-id="element-127" data-mp="2p0h5riga112d" />
              Text us for immediate booking
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}